module.exports = __webpack_public_path__ + "img/complete-vehicle.a6e5dbf5.png";